import { DataContext } from "@/types";
import { Data } from "../Data";

export class LocationSelectorList extends Data {
  static instance: LocationSelectorList | null = null;
  locations: any;
  attributes: any;

  constructor(options: any) {
    super({
      api:
        (options.groupId
          ? "/MyGroup/" + options.groupId + "/GetLocations"
          : "/Teams/GetLocations") +
        "?searchText=" +
        options.search,
      callback: (data: any) => {
        options.resolve(this, false);
      },
      ...options
    });
  }

  onDataReceived(data: any) {
    console.log('LocationSelectorList onDataReceived', data);

    this.locations = data.locations;
  }

  static getLocationSelectorList(context: DataContext, search: string, groupId?: string): Promise<LocationSelectorList> {
    return new Promise((resolve, reject) => {
      if (LocationSelectorList.instance && search === "")
        resolve(LocationSelectorList.instance);
      else
        LocationSelectorList.instance = new LocationSelectorList({
          resolve,
          reject,
          search,
          context,
          groupId
        });
    });
  }

  findMatch(attr: any) {
    return this.attributes.find((a: any) => a.name === attr);
  }
}
